import uniqueId from "./unique_id";
import trans from "trans/index"
import _forEach from "lodash/forEach"

import {
    POST_CUSTOM_IMAGE_SET_FILE,
    POST_RENDER_PREVIEW_IMAGE,
    POST_TEMPLATE,
    TEMPLATE_NOT_FOUND,
    SAVE_CUSTOM_IMAGE_SET,
    UPLOAD_IMAGE_FILE,
    IMPORT_JSON_TEMPLATE,
    DELETE_IMAGE_FROM_CUSTOM_SET,
    DELETE_CUSTOM_IMAGE_SET,
    SET_MISTAKE_BY_USER,
    UPDATE_SETTINGS,
    SAVE_SIZES,
    SET_WATERMARK_BY_USER,
    GET_COLLAGE_LAYOUTS,
    SAVE_COLLAGE_LAYOUTS,
    DELETE_COLLAGE_LAYOUTS,
    ADD_COLLAGE_LAYOUT,
    ADD_COLLAGE_LAYOUT_IMAGE,
    DELETE_COLLAGE_LAYOUT_IMAGE,
    SAVE_COLLAGE_LAYOUT,
    CREATE_DEFAULT_COLLAGE_LAYOUTS,
    DELETE_ALL_UNUSED_COLLAGE_LAYOUTS,
    SAVE_SETTINGS_ORDER, SET_QUALITY_BY_USER,
    SET_TEMPLATE_ACTIVE_DATE, INVALID_FIELD_VALUE,
    LAYER_COPIED, GENERAL_ERROR, GET_CUSTOM_PALETTES, SAVED_OK, GENERAL_SUCCESS,
} from "template-edit/reducers"

type toastTypes = "info" | "error" | "success" | "warning"

export interface Toast {
    content: string
    icon?: any
    type: toastTypes
    ttl: number
    id: string
}

export interface ResponseErrorType {
    message: string
    response: {
        status: number
        data: any
        headers: any
        statusText: string
    }
}

export function createToast(content: string, type: toastTypes = "info", ttl = 10, icon = null) {
    return {
        content,
        type,
        icon,
        ttl,
        id: uniqueId()
    }
}

export function textToast(type: toastTypes, text: string, ttl: number = 2, icon = null) {
    return createToast(text, type, ttl, icon)
}

export default function (type: string, error: ResponseErrorType = null) {
    if (error?.response?.status === 401)  {
        console.error('Error 401', error?.response)
        return;
    }
    
    let errorMsg : string = trans("general_error")+": ";

    if (error && error.response && error.response.data && error.response.status !== 200) {        
        //validation errors
            if (error.response.data.validation_errors) {
                if (typeof error.response.data.validation_errors === 'string') {
                    errorMsg += trans(error.response.data.validation_errors)
                } else {
                    _forEach(error.response.data.validation_errors, (value, key) => {
                        if (trans('validation_error_' + key) !== 'validation_error_' + key) {
                            errorMsg += " " + trans('validation_error_' + key)
                        } else {
                            errorMsg += key + ', '
                        }
                    })
                }
            } else if (error.response.data.message) {
                errorMsg += " " + error.response.data.message
            } else if (error.response.data.error) {
                errorMsg += " " + error.response.data.error
            } else {
                console.error('error toast', error)
            }
    }

    switch (type) {
        case GENERAL_ERROR:
            return createToast(errorMsg, "error", 5)
        case GENERAL_SUCCESS:
            return createToast(trans('success'), "success", 2)
        case SAVED_OK:
            return createToast(trans('saved'), "success", 2)
        case SAVE_SIZES.SUCCESS:
            return createToast(trans("save_sizes_success"), "success", 5)
        case SAVE_SIZES.ERROR:
            return createToast(trans("save_sizes_error"), "error", 5)
        case SAVE_SETTINGS_ORDER.SUCCESS:
            return createToast(trans("save_settings_order_success"), "success", 5)
        case SAVE_SETTINGS_ORDER.ERROR:
            return createToast(trans("save_settings_order_error"), "error", 5)
        case UPDATE_SETTINGS.SUCCESS:
            return createToast(trans("settings_update_success"), "success", 5)
        case UPDATE_SETTINGS.ERROR:
            return createToast(trans("settings_update_error"), "error", 5)
        case SET_TEMPLATE_ACTIVE_DATE.SUCCESS:
            return createToast(trans("set_template_active_date_success"), "success", 5)
        case SET_TEMPLATE_ACTIVE_DATE.ERROR:
            return createToast(trans("set_template_active_date_error"), "error", 5)
        case SET_QUALITY_BY_USER.SUCCESS:
        case SET_WATERMARK_BY_USER.SUCCESS:
        case SET_MISTAKE_BY_USER.SUCCESS:
            return createToast(trans("mistake_by_user_successfully_changed"), "success", 1)
        case SET_QUALITY_BY_USER.ERROR:
        case SET_WATERMARK_BY_USER.ERROR:
        case SET_MISTAKE_BY_USER.ERROR:
            return createToast(trans("set_mistake_by_user_error"), "error", 5)
        case SAVE_CUSTOM_IMAGE_SET.ERROR:
            return createToast(errorMsg, "error", 5)
        case POST_CUSTOM_IMAGE_SET_FILE.SUCCESS:
            return createToast(trans("custom_image_set_uploaded"), "success", 5)
        case DELETE_IMAGE_FROM_CUSTOM_SET.SUCCESS:
            if (error.message === 'custom_image_set_cannot_remove_error' || error.message === 'custom_image_set_cannot_remove_is_used') {
                return createToast(trans(error.message), "error", 5)
            }
            return createToast(trans(error.message), "success", 5)
        case DELETE_IMAGE_FROM_CUSTOM_SET.ERROR:
            return createToast(trans(error.message), "error", 5)
        case DELETE_CUSTOM_IMAGE_SET.SUCCESS:
            if (error.message === 'custom_image_set_delete_set_is_used') {
                return createToast(trans(error.message), "error", 5)
            }
            return createToast(trans(error.message), "success", 5)
        case DELETE_CUSTOM_IMAGE_SET.ERROR:
            return createToast(trans(error.message), "error", 5)
        case GET_COLLAGE_LAYOUTS.ERROR:
            return createToast(trans(error.message), "error", 5)
        case GET_CUSTOM_PALETTES.ERROR:
            return createToast(trans(error.message), "error", 5)
        case POST_CUSTOM_IMAGE_SET_FILE.ERROR:
            return createToast(errorMsg, "error", 5)
        case INVALID_FIELD_VALUE:
            const {name} = error.response.data
            return createToast(trans(error.message) + ' ' + trans(name), "error", 2)
        case POST_TEMPLATE.SUCCESS:
            return createToast(trans("template_saved"), "success", 5)
        case POST_RENDER_PREVIEW_IMAGE.ERROR:
            return createToast(errorMsg, "error", 15)
        case UPLOAD_IMAGE_FILE.SUCCESS:
            return createToast(trans("file_uploaded"), "success", 5)
        case UPLOAD_IMAGE_FILE.ERROR:
            const message = trans(error.message || 'upload_error_unsupported_type')
            return createToast(message, "error", 15)
        case IMPORT_JSON_TEMPLATE.SUCCESS:
            return createToast(trans("import_template_success"), "success", 5)
        case IMPORT_JSON_TEMPLATE.ERROR:
            return createToast(trans('import_template_error') + ': ' + (error.message || '') , "error", 15)
        case TEMPLATE_NOT_FOUND:
            return createToast(trans('template_not_found'), "error", 15)
        case ADD_COLLAGE_LAYOUT.ERROR:
            return createToast(trans('add_layout_error'), "error", 15)
        case ADD_COLLAGE_LAYOUT_IMAGE.ERROR:
            return createToast(trans('add_layout_image_error') + ' ' + errorMsg, "error", 15)
        case SAVE_COLLAGE_LAYOUT.ERROR:
            return createToast(trans('save_layouts_error') + ' ' + errorMsg, "error", 15)
        case SAVE_COLLAGE_LAYOUTS.ERROR:
            return createToast(trans('save_layouts_error') + ' ' + errorMsg, "error", 15)
        case ADD_COLLAGE_LAYOUT.SUCCESS:
            return createToast(trans("add_layout_success"), "success", 5)
        case DELETE_ALL_UNUSED_COLLAGE_LAYOUTS.SUCCESS:
            return createToast(trans("delete_all_unused_success"), "success", 5)
        case DELETE_ALL_UNUSED_COLLAGE_LAYOUTS.ERROR:
            return createToast(trans("delete_all_unused_error") + ' ' + errorMsg, "error", 15)
        case ADD_COLLAGE_LAYOUT_IMAGE.SUCCESS:
            return createToast(trans("add_layout_image_success"), "success", 5)
        case SAVE_COLLAGE_LAYOUT.SUCCESS:
            return createToast(trans("save_layouts_success"), "success", 5)
        case SAVE_COLLAGE_LAYOUTS.SUCCESS:
            return createToast(trans("save_layouts_success"), "success", 5)
        case CREATE_DEFAULT_COLLAGE_LAYOUTS.SUCCESS:
            return createToast(trans("create_default_layouts_success"), "success", 5)
        case CREATE_DEFAULT_COLLAGE_LAYOUTS.ERROR:
            return createToast(trans("create_default_layouts_error") + ' ' + errorMsg, "error", 15)
        case DELETE_COLLAGE_LAYOUT_IMAGE.ERROR:
            return createToast(trans('delete_layout_image_error' + ' ' + errorMsg), "error", 15)
        case DELETE_COLLAGE_LAYOUTS.ERROR:
            return createToast(trans('delete_layouts_error'), "error", 15)
        case DELETE_COLLAGE_LAYOUTS.SUCCESS:
        case DELETE_COLLAGE_LAYOUT_IMAGE.SUCCESS:
            return createToast(trans("delete_layouts_success"), "success", 5)
        case LAYER_COPIED:
            return createToast(trans("layer_copied"), "success", .5)
        case POST_TEMPLATE.ERROR:
            if (error) {
                if (error.response && error.response.status === 400) {
                    //keep errorMsg
                } else if (error.response && error.response.data && error.response.data.message) {  //error 500 message
                    errorMsg = error.response.data.message
                } else if (error.message) {
                    errorMsg = error.message
                }
            }
            return createToast(errorMsg, "error", 15)
        default:
            return createToast('', "success", 0)
    }
}